import findSeasonContentForSchoolLevel from "./find-season-content-for-school-level";

export default function resolveRoutedSeason(
  route,
  { parentSeason, parentSchoolLevel },
  { getters },
) {
  if (!getters.containerLoaded) {
    return null;
  }

  // If no school level or no season is provided, we fall back
  // to the auto 'season content for school level'.
  if (!parentSeason || !parentSchoolLevel) {
    return null;
  }

  // If a season slug route parameter is provided, we use this
  // parameter to match one of the selected volume's seasons.
  // If none matches because the season slug route param
  // is invalid, then an automatic fallback is chosen.
  return findSeasonContentForSchoolLevel(parentSeason, parentSchoolLevel);
}
